export enum LoginFormField {
  Email = 'Email',
  Password = 'Password',
  Remember = 'RememberLogin',
}
export enum ResetPasswordField {
  NewPassword = 'New Password',
  ConfirmPassword = 'Confirm Password',
}

export type LoginFormValues = {
  [LoginFormField.Email]: string;
  [LoginFormField.Password]: string;
  [LoginFormField.Remember]: boolean;
};

export enum VerifyOtpField {
  UserId = 'UserId',
  VerificationCode = 'VerificationCode',
}
export type VerifyOtpFormValues = {
  [VerifyOtpField.UserId]: string;
  [VerifyOtpField.VerificationCode]: string;
};

export type ResetPasswordFormValues = {
  [ResetPasswordField.NewPassword]: string;
  [ResetPasswordField.ConfirmPassword]: string;
};
